<template>
    <div id="modal-atalho-territorio">
        <el-dialog
            width="600px"
            :title="$t('certification.messages.territory_already_analyzed')"
            :visible.sync="mostrar"
            :close-on-click-modal="false"
            :before-close="fechar"
        >
      <span class="espacamento">
        {{ $t('certification.messages.existing_certification_analysis_for_selected_territories') }}
      </span>

            <div class="flexContainer" v-for="(item, index) in lista" :key="index">
                <div class="linha">
                    {{ item.geometrias[0].nomeTerritorio }}
                    <el-button
                        class="btnMargin"
                        type="primary"
                        @click="goToAnalise(item.id)"
                    >
                        {{ $t('certification.messages.view_existing') }}
                    </el-button>
                </div>
            </div>
            <div class="botoes">
                <el-button @click="fechar(false)">
                    {{ $t('certification.words.back') }}
                </el-button>
                <el-button type="primary" @click="fechar(true)">
                    {{ $t('certification.messages.new_certification_analysis') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'ModalAtalhoTerritorio',
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },
        lista: {
            type: Array
        }
    },
    methods: {
        fechar(confirma) {
            if (confirma) {
                this.$emit('fechar', true);
            }
            this.$emit('fechar', false);
        },
        goToAnalise(idCertificacao) {
            this.$router.push({
                name: 'VisualizarAnalise',
                params: { idCertificacao }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.botoes {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
}

.espacamento {
    word-break: break-word;
}
.margin {
    margin-top: 20px;
}
.linha {
    display: flex;
}
.btnMargin {
    margin: 0 auto 0 20px;
}
.flexContainer {
    display: flex;
    justify-content: space-between;
}
</style>
